export default {
  "3d_rotation": "ThreeDRotation",
  "4k": "FourK",
  "360": "ThreeSixty",
};
